<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import UserWelcome from '@/components/user/UserWelcome.vue'
import HostOverview from '@/components/content/HostOverview.vue'

const userStore = useUserStore()
const currentUser = storeToRefs(userStore)
const isLoggedIn = ref(currentUser.isLoggedin)

const hosts = computed(() => {
  const hosts = userStore.account?.profile?.hosts ?? []
  return hosts
})
</script>
<template>
  <div v-if="isLoggedIn">
    <!-- user summary -->
    <!--    <v-sheet>-->
    <!--      <p>{{ userStore.fullname() }} <br />{{ userStore.email() }}</p>-->
    <!--    </v-sheet>-->

    <UserWelcome />
  </div>

  <div v-if="isLoggedIn">
    <template v-for="host in hosts" :key="host.id">
      <!--      {{ host.players }}-->
      <HostOverview :host="host" />
    </template>
  </div>

  <div v-else>
    <p>You're not logged in ..</p>
  </div>
</template>
<style lang="scss" scoped>
.active {
  font-weight: bold;
}
</style>
